import t from "react";
var r = t.createContext(null);
export { r as default };